import lib from '@/library'

const state = {
  date: undefined,
  meetings: undefined,
  results: undefined
}

const getters = {
  getDate (state) {
    return state.race
  },
  getMeetings (state) {
    return state.meetings
  },
  getResults (state) {
    return state.racerp
  }
}

const mutations = {
  setDate (state, race) {
    state.race = race
  },
  setMeetings (state, meetings) {
    state.meetings = meetings
  },
  setResults (state, data) {
    state.racerp = data
  }
}

const actions = {
  fetchMeetings (context, date) {
    // context.commit('setAreMeetingsLoaded', false)

    return lib.kansas.totedailyracecard({
      date: date,
      language: 'UK' // TODO: change to configured language once it is optimized
    }).then(response => {
      let meetingsWithFinishedRaces = []

      if (response.data.racecard.meetings.meeting && response.data.racecard.meetings.meeting.length > 0) {
        meetingsWithFinishedRaces = response.data.racecard.meetings.meeting.filter(function (meeting) {
          let hasFinishedRace = false
          let races = meeting.races.race
          for (var i = 0; i < races.length; i++) {
            if (races[i].alias) {
              hasFinishedRace = true
              break
            }
          }
          return hasFinishedRace
        })
      }
      context.commit('setMeetings', meetingsWithFinishedRaces || [])
    }).catch(() => {
      context.commit('setMeetings', [])
    })
  },

  fetchResults (context, idtgrace) {
    var self = this
    context.commit('setResults', undefined)

    lib.kansas.toteRaceResults({
      idtgrace: idtgrace
    }).then(response => {
      var results = response.data

      if (results && results.pools) {
        // Hide non-supported pool types
        results.poolsfordisplay = results.pools.filter(pool => pool.type !== 'PLACE' &&
          (self.getters['betslipState/getAvailableRPTypes'].indexOf(pool.type) > -1 ||
            self.getters['betslipState/getAvailableRCTypes'].indexOf(pool.type) > -1 ||
            self.getters['betslipState/getAvailableMRTypes'].indexOf(pool.type) > -1))

        // Show non-supported pool types
        // race.poolsfordisplay = race.pools.filter(pool => pool.type !== 'PLACE')
      }

      context.commit('setResults', response.data)
    }).catch((error) => {
      console.log(error)
      context.commit('setResults', undefined)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/hrresults.js